import { client } from '../../../../../common-utils/libraries/axios/axios';
import SESSION from '../apiUrls';

const mutationInitializeMFa = (onSuccess, onError) => {
    return {
        mutationFn: ({ totp, mfaSecret }) => {
            return client.post(SESSION.INITIALIZE_MFA.url, { totp, mfaSecret });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: (data) => {
            onSuccess(data);
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationInitializeMFa;